/**
 * Validación de variables de entorno requeridas al arrancar la app.
 * Falla con un mensaje claro si falta alguna, en vez de romper en runtime.
 */
import { logger } from "utils/logger";

const REQUIRED_ENV_VARS = ["REACT_APP_API_URL", "REACT_APP_IMAGES_URL"];

export const validateEnv = () => {
  const missing = REQUIRED_ENV_VARS.filter((key) => !process.env[key]);
  if (missing.length > 0) {
    logger.error(
      `[OneFIN] Faltan variables de entorno requeridas: ${missing.join(", ")}. ` +
        "Verificá tu archivo .env."
    );
  }
  return missing;
};

export const getEnv = (key, fallback = "") => process.env[key] || fallback;

const env = { validateEnv, getEnv };
export default env;
